/**
 * `calendar` translations, for every locale -- the Outlook calendar page.
 * The nav label `app.calendar` lives in shell.ts with the other nav keys; the
 * page reuses it as its heading.
 */
export const calendar = {
  mn: {
    calendar: {
      hint: 'Outlook хуанлийн үйл явдлууд. Ажилтан сонгож түүний хуанлийг харна уу.',
      person: 'Хэний хуанли',
      me: '(би)',
      scope: 'Харуулах арга хэмжээ',
      scopes: { personal: 'Хувийн', both: 'Хоёулаа', company: 'Компани' },
      company: 'Компани',
      prevMonth: 'Өмнөх сар',
      nextMonth: 'Дараах сар',
      thisMonth: 'Энэ сар',
      loading: 'Ачаалж байна…',
      loadFailed: 'Хуанлийг ачаалж чадсангүй.',
      noEvents: 'Энэ өдөр үйл явдал алга.',
      noSubject: '(гарчиггүй)',
      showDetails: 'Дэлгэрэнгүй',
      leaveLoadFailed: 'Чөлөөний мэдээллийг ачаалж чадсангүй.',
      allDay: 'Өдөржин',
      dayTotal: 'Нийт үргэлжлэх хугацаа: {{duration}}',
      allDayNotCounted: 'өдөржингийн үйл явдлыг тооцоогүй',
      more: '+{{count}} бусад',
      start: 'Эхлэх',
      duration: 'Үргэлжлэх',
      location: 'Байршил',
      organizer: 'Зохион байгуулагч',
      booked: 'Бүртгэсэн цаг',
      planned: 'Төлөвлөсөн цаг',
      away: 'Чөлөөтэй',
      halfDay: 'Хагас өдөр',
      byProject: 'Төслөөр',
      byActivity: 'Үйл ажиллагаараа',
      noProject: '(төсөлгүй)',
      stateNoMailbox: 'Энэ хүнд Outlook хуанли байхгүй.',
      stateNotOffered: 'Танай байгууллагад Outlook хуанли идэвхжүүлээгүй байна.',
      stateNotConfigured: 'Хуанлийн холболт тохируулагдаагүй байна.',
      stateConsentPending: 'Microsoft хуанли унших зөвшөөрөл хараахан олгогдоогүй байна. Админд хандана уу.',
      stateUnavailable: 'Хуанли одоогоор боломжгүй байна. Дараа дахин оролдоно уу.',
    },
  },
  en: {
    calendar: {
      hint: 'Outlook calendar events. Pick a colleague to see their calendar.',
      person: 'Whose calendar',
      me: '(me)',
      scope: 'Events to show',
      scopes: { personal: 'Personal', both: 'Both', company: 'Company' },
      company: 'Company',
      prevMonth: 'Previous month',
      nextMonth: 'Next month',
      thisMonth: 'This month',
      loading: 'Loading…',
      loadFailed: 'Could not load the calendar.',
      noEvents: 'No events on this day.',
      noSubject: '(no subject)',
      showDetails: 'Show details',
      leaveLoadFailed: 'Could not load who is away.',
      allDay: 'All day',
      dayTotal: 'Total duration: {{duration}}',
      allDayNotCounted: 'all-day events not counted',
      more: '+{{count}} more',
      start: 'Start',
      duration: 'Duration',
      location: 'Location',
      organizer: 'Organizer',
      booked: 'Time booked',
      planned: 'Planned',
      away: 'Away',
      halfDay: 'Half day',
      byProject: 'By project',
      byActivity: 'By activity',
      noProject: '(none)',
      stateNoMailbox: 'This person has no Outlook calendar.',
      stateNotOffered: 'Outlook calendars are not switched on for your organization.',
      stateNotConfigured: 'The calendar connection is not set up.',
      stateConsentPending: 'Microsoft has not yet been allowed to share calendars with this app. Ask an administrator.',
      stateUnavailable: 'The calendar is unavailable right now. Try again later.',
    },
  },
  ru: {
    calendar: {
      hint: 'События календаря Outlook. Выберите сотрудника, чтобы увидеть его календарь.',
      person: 'Чей календарь',
      me: '(я)',
      scope: 'Какие события показать',
      scopes: { personal: 'Личный', both: 'Оба', company: 'Компания' },
      company: 'Компания',
      prevMonth: 'Предыдущий месяц',
      nextMonth: 'Следующий месяц',
      thisMonth: 'Этот месяц',
      loading: 'Загрузка…',
      loadFailed: 'Не удалось загрузить календарь.',
      noEvents: 'В этот день событий нет.',
      noSubject: '(без темы)',
      showDetails: 'Подробнее',
      leaveLoadFailed: 'Не удалось загрузить отсутствующих.',
      allDay: 'Весь день',
      dayTotal: 'Общая длительность: {{duration}}',
      allDayNotCounted: 'события на весь день не учтены',
      more: '+{{count}} ещё',
      start: 'Начало',
      duration: 'Длительность',
      location: 'Место',
      organizer: 'Организатор',
      booked: 'Учтено времени',
      planned: 'Запланировано',
      away: 'Отсутствует',
      halfDay: 'Полдня',
      byProject: 'По проектам',
      byActivity: 'По видам работ',
      noProject: '(нет)',
      stateNoMailbox: 'У этого человека нет календаря Outlook.',
      stateNotOffered: 'Календари Outlook для вашей организации не подключены.',
      stateNotConfigured: 'Подключение календаря не настроено.',
      stateConsentPending: 'Microsoft ещё не разрешил приложению читать календари. Обратитесь к администратору.',
      stateUnavailable: 'Календарь сейчас недоступен. Попробуйте позже.',
    },
  },
}
